import Experience  from '../../Experience.js'
import EventEmitter from '../Utils/EventEmitter.js'
import Environment from './Environment.js'
import Weather     from './Weather.js'
import Menu        from './Menu.js'
import * as THREE from 'three'

export default class World extends EventEmitter {
    constructor()
    {
        super()

        // Setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.loader = this.experience.loader

        this.environment = null
        this.weather = null
        this.menu = null

        // Events
        this.loader.on('ready', () => this.create())
    }

    // Instantiate Methods
    create()
    {
        this.menu = new Menu()
        this.createEnvironment()
    }

    createEnvironment()
    {
        this.environment = new Environment()
        this.weather = new Weather()
    }

    // Animate World
    update()
    {
        if(this.weather !== null)
        {
            this.weather.update()
        }
        if(this.menu !== null)
        {
            this.menu.update()
            this.trigger('menuLoaded')
        }
    }
}